import EditMarketDesktopView from "./desktop/EditMarket.desktop.view";
import CanEditMarket from "../../security/CanEditMarket";
import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";

export default function EditMarketView() {
  const isDesktop = useIsDesktopDevice();

  return <>{CanEditMarket() && isDesktop && <EditMarketDesktopView />}</>;
}
